export default __webpack_public_path__ + "static/media/TCSenseCarNoSignal.b8349127.svg";